import { render, staticRenderFns } from "./ProductPicture.vue?vue&type=template&id=2f0c6382&scoped=true&"
import script from "./ProductPicture.vue?vue&type=script&lang=js&"
export * from "./ProductPicture.vue?vue&type=script&lang=js&"
import style0 from "./ProductPicture.vue?vue&type=style&index=0&id=2f0c6382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c6382",
  null
  
)

export default component.exports